import React, {Component} from "react";
import Modal from "./ModalTemplate";
import CategorySelectComp from "../../pages/selfmessage/message/component/CategorySelectComp";
import * as apiUtil from "../../util/apiUtil";
import Loading from "../loading/Loading";

class UpdateCateModal extends Component {
    constructor(props){
        super(props);

        this.setLoading = this.setLoading.bind(this);
        this.ajaxPostUpdateCate = this.ajaxPostUpdateCate.bind(this);
        this.setCateValue = this.setCateValue.bind(this);
        this.state = {
            loading: false,
            mainCateID: 1,
            midCateID: 1,
            subCateID: 1,
        }
    }// end constructor

    setLoading(loading) {
        this.setState({ loading: loading });
    }

    setCateValue(id, value) {
        switch (id) {
            case "main":
                this.setState({ mainCateID: value });
                break;
            case "mid":
                this.setState({ midCateID: value });
                break;
            case "sub":
                this.setState({ subCateID: value });
                break;
            default:
                break;
        }// end switch
    }// end func

    ajaxPostUpdateCate() {
        const { mainCateID, midCateID, subCateID } = this.state;
        const { isClose } = this.props;
        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/user/category/update",
            method: apiUtil.requestMethod.POST,
            data: {
                mainCategoryId: mainCateID,
                midCategoryId: midCateID,
                subCategoryId: subCateID,
            },
            success: (result) => {
                alert("성공적으로 변경되었습니다!");
                isClose();
            }
        })
    }// end ajaxPostUpdate

    render() {
        const { loading } = this.state;
        const { mainCateID, midCateID, subCateID } = this.state;

        const { isOpen, isClose } = this.props;
        const { setCateValue, ajaxPostUpdateCate } = this;
        return (
            <Modal
            open={isOpen}
            handleClose={isClose}
            modalTitle={"타겟팅 희망 카테고리 상품 수정"}
            className={"react-modal"}
            >
                <Loading loading={loading}/>
                <div className="modal-body d-flex justify-content-center align-items-center">
                    <CategorySelectComp
                        setCateValue={setCateValue}
                        main={mainCateID}
                        mid={midCateID}
                        sub={subCateID}
                    />
                </div>
                <div className="modal-footer d-flex justify-content-center">
                    <button className={"btn btn-primary btn-md mx-2"}
                    onClick={() => {
                        if(window.confirm("해당 카테고리로 변경하시겠습니까?")) ajaxPostUpdateCate();
                    }
                    }
                    >확인</button>

                    <button className={"btn btn-secondary btn-md"}
                    onClick={() => {
                        if(window.confirm("타겟팅 희망 카테고리 수정을 취소 하시겠습니까?")) isClose();
                    }}>취소</button>
                </div>
            </Modal>
        )
    }
}// end class
export default UpdateCateModal;

